import Edit from '@mui/icons-material/Edit';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EditIcon(props: FixMe) {
  return <Edit {...props} />;
}

export default EditIcon;
